import { Controller } from '@hotwired/stimulus';

export default class AscertainAnswerController extends Controller {
  static targets = [
    'answerTextField'
  ];

  ready(e) {
    this.answerTextFieldTarget.value = e.detail.answer;
  }

  notReady() {
    this.answerTextFieldTarget.value = '';
  }
}
